import React from 'react';
import { View } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../constants/ScreenNames';
import ExpenseSummaryCard from './ExpenseSummaryCard';
import { EXPENSE_SUB_TAB_OPTIONS } from '../../constants/Enums';
import { isMileageExpense } from '../../utils/expense.utils';

const ExpenseCard = ({
  item,
  isEditable = true,
  isReportCardModal = false,
  showExclamationIcon = false,
}) => {
  const navigation = useNavigation();
  const isCarMileageExpense = isMileageExpense(item);
  return (
    <View>
      <ExpenseSummaryCard
        item={item}
        showExclamationIcon={showExclamationIcon}
        isEditable={isEditable}
        // This is the only way to reach the Expense Modal for editing/updating the expense
        onPress={() => {
          navigation.navigate(Modals.CreateExpenseModal, {
            item,
            isCarMileageExpense,
            isEditable,
            subTab: EXPENSE_SUB_TAB_OPTIONS.ANY,
          });
        }}
        pressDisabled={!isReportCardModal}
      />
    </View>
  );
};

export default ExpenseCard;
